import { Endpoints } from "../../endpoints";

export const getPrivacyPolicyText = async () => {
  const x = await document
    .querySelector("a-scene")
    .systems.data.fetch(Endpoints.privacyPolicyPage());

  const privacyPolicyLang = "en";

  return x[privacyPolicyLang];
};

export const getCreditCardPrivacyPolicyText = async () => {
  const x = await document
    .querySelector("a-scene")
    .systems.data.fetch(Endpoints.creditCardPrivacyPolicyPage());

  const privacyPolicyLang = "en";

  return x[privacyPolicyLang];
};
